<template>
  <div
    class="action_btn_wrapper"
    :style="'width: ' + btnWidth + 'px;'"
  >
    <button
      type="button"
      class="action_btn"
      @click="clickBtn"
    >
      {{ btnText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'CustomActionBtn',
  props: {
    btnText: {
      type: String,
      default () {
        return '下一步';
      }
    },
    btnWidth: {
      type: [Number, String],
      default () {
        return 327;
      }
    }
  },
  emits: ['btn-click'],
  setup (props, { emit }) {
    const clickBtn = () => {
      emit('btn-click');
    };

    return {
      clickBtn
    };
  }
};
</script>

<style lang="scss" scoped>
@import '@/scss/common/common.scss';

.action_btn_wrapper {
  display: inline-block;
  pointer-events: auto;
  text-align: center;

  .action_btn {
    background: $black;
    border: none;
    border-radius: 30px;
    box-shadow: 5px 7px 0px 0px $green;
    color: $white;
    cursor: pointer;
    display: inline-block;
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    outline: none;
    padding: 16px 0px;
    width: 100%;
  }
}
</style>
